import React, {useContext, useEffect} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import './styles/App.scss';
import './styles/ButtonStyles.scss';
import './styles/FormStylesheet.scss';
import './styles/ModalStylesheet.scss';
import './styles/RetroY2KProfileStylesheet.scss';
import './styles/CelestialProfileStylesheet.scss';
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {SignUpPage} from "./screens/signUp/signUp.page";
import {ProfileOr404Page} from "./screens/profile/profileOr404.page";
import {FixedRoute} from "./common/enums/route.enum";
import {ShareImagePage} from "./screens/quiz/shareImage.page";
import {CreatePassword} from "./screens/account/createPassword.page";
import {ThatsMeBabyContext} from "./common/contexts/thatsMeBabyContext";
import {LoadingPage} from "./screens/loading/loading.page";
import AccountSettings from "./screens/account/accountSettings.page";
import {SignInSSOPage} from "./screens/sign-in/signInSSO.page";
import {SignUpSSOPage} from "./screens/signUp/signUpSSO.page";
import {ForgotPassword} from "./screens/account/forgotPassword.page";
import CreateProfilePage from "./screens/profile/create/createProfile.page";
import EditProfilePage from "./screens/profile/edit/editProfile.page";
import CompatibilityGuestHomePage from "./screens/compatibility/compatibilityGuestHome.page";
import CompatibilityUserHomePage from "./screens/compatibility/compatibilityUserHome.page";
import {CompatibilityUserPage} from "./screens/compatibility/compatibilityUser.page";
import SignUpOptionsPage from "./screens/signUp/signUpOptions.page";
import SignInPage from "./screens/sign-in/signIn.page";
import {CompatibilityCelebrityPage} from "./screens/compatibility/compatibilityCelebrity.page";
import {PreviewPage} from "./screens/profile/preview.page";
import UnsubscribePage from "./screens/unsubscribe/unsubscribe.page";

function App() {

    const {isLoggedIn, profile, isFinishedLoadingProfileData} = useContext(ThatsMeBabyContext);


    useEffect(() => {
        if (window.location.href.indexOf("#_=_") > -1) {

            //remove facebook oAuth response bogus hash
            if (window.history) {
                history.pushState('', document.title, window.location.href.replace(location.hash, ""));
            } else {
                window.location.href = window.location.href.replace(location.hash, "");
            }
        }
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path={`/${FixedRoute.Home}`} element={<SignInPage/>}/>
                <Route path={`/${FixedRoute.SignUp}`} element={<SignUpPage/>}/>
                <Route path={`/${FixedRoute.SignUpSSO}`} element={<SignUpSSOPage/>}/>
                <Route path={`/${FixedRoute.SignUpOptions}`} element={<SignUpOptionsPage/>}/>
                <Route path={`/${FixedRoute.SignIn}`} element={<SignInPage/>}/>
                <Route path={`/${FixedRoute.SignInSSO}`} element={<SignInSSOPage/>}/>
                <Route path={`/${FixedRoute.New}`} element={<CreateProfilePage/>}/>
                <Route path={`/${FixedRoute.Share}`} element={<ShareImagePage/>}/>
                <Route path={`/${FixedRoute.ForgotPassword}`} element={<ForgotPassword/>}/>
                <Route path={`/${FixedRoute.ResetPassword}`} element={<CreatePassword/>}/>
                <Route path={`/${FixedRoute.CompatibilityUser}/:id`} element={<CompatibilityUserPage/>}/>
                <Route path={`/${FixedRoute.CompatibilityCelebrity}/:id`} element={<CompatibilityCelebrityPage/>}/>
                <Route path={`/${FixedRoute.Compatibility}`} element={isFinishedLoadingProfileData ? (isLoggedIn && profile ? <CompatibilityUserHomePage/> : <CompatibilityGuestHomePage/>) : <LoadingPage/>}/>
                <Route path={`/${FixedRoute.Preview}`} element={<PreviewPage/>}/>
                <Route path={`/${FixedRoute.Unsubscribe}`} element={<UnsubscribePage/>}/>
                {/* Logged in routes */}
                <Route path={`/${FixedRoute.Settings}`} element={isLoggedIn && profile ? <AccountSettings/> : <LoadingPage/>}/>
                <Route path={`/${FixedRoute.Edit}`} element={isLoggedIn && profile ? <EditProfilePage/> : <LoadingPage/>}/>
                {/* Other routes */}
                <Route path="*" element={<ProfileOr404Page/>}/>
            </Routes>
            <ToastContainer position="bottom-right"/>
        </BrowserRouter>
    );
}

export default App;
